import { useMemo, useState } from "react";
import Breadcrumb from "@/components/base/Breadcrumb";
import Pagination from "@/components/base/Pagination";
import TopicCard from "@/components/feature/TopicCard";
import EmptyState from "@/components/feature/EmptyState";
import { topics, topicTags } from "@/mocks/topics";
import { useDocumentMeta } from "@/hooks/useDocumentMeta";

const PAGE_SIZE = 5;

export default function TopicsCategory() {
  useDocumentMeta({
    title: "网络话题 - 巨乳娱乐资讯网",
    description:
      "巨乳娱乐资讯网网络话题栏目，追踪影视热议、明星动态、票房口碑与行业观察等热门讨论，帮你快速掌握网络舆论焦点。",
    keywords: "网络话题,热门讨论,影视热议,明星动态,娱乐资讯,巨乳娱乐资讯网",
  });

  const [tag, setTag] = useState("全部");
  const [page, setPage] = useState(1);

  const filtered = useMemo(
    () => (tag === "全部" ? topics : topics.filter((item) => item.tag === tag)),
    [tag],
  );

  const totalPages = Math.max(1, Math.ceil(filtered.length / PAGE_SIZE));
  const currentPage = Math.min(page, totalPages);
  const pageItems = filtered.slice(
    (currentPage - 1) * PAGE_SIZE,
    currentPage * PAGE_SIZE,
  );

  const handleTag = (value: string) => {
    setTag(value);
    setPage(1);
  };

  return (
    <div className="mx-auto w-full max-w-7xl px-4 py-6 md:px-8 md:py-8">
      <Breadcrumb items={[{ label: "首页", to: "/" }, { label: "网络话题" }]} />

      <div className="mt-4 flex flex-col gap-2">
        <h1 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
          网络话题
        </h1>
        <p className="max-w-3xl text-sm leading-relaxed text-foreground-600">
          追踪网络上正在被讨论的娱乐焦点：影视口碑、明星动态、票房表现与行业观察。
          点击标签即可筛选感兴趣的方向，进入话题详情查看完整内容与相关作品。
        </p>
      </div>

      <div className="mt-5 flex flex-wrap gap-2">
        {["全部", ...topicTags].map((item) => (
          <button
            key={item}
            type="button"
            onClick={() => handleTag(item)}
            className={`whitespace-nowrap rounded-full px-3 py-1 text-xs transition-colors cursor-pointer md:text-sm ${
              tag === item
                ? "bg-accent-500 text-background-50"
                : "bg-background-100 text-foreground-700 hover:bg-secondary-100 hover:text-secondary-900"
            }`}
          >
            {item}
          </button>
        ))}
      </div>

      <div className="mt-4 flex flex-wrap items-center gap-3">
        <span className="text-sm text-foreground-500">
          共 <strong className="text-primary-600">{filtered.length}</strong> 个话题
        </span>
      </div>

      {pageItems.length > 0 ? (
        <div className="mt-5 grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
          {pageItems.map((topic) => (
            <TopicCard key={topic.id} topic={topic} />
          ))}
        </div>
      ) : (
        <div className="mt-5">
          <EmptyState
            title="该标签下暂无话题"
            description="试试切换其他标签，或者查看全部话题。"
            actionLabel="查看全部话题"
            onAction={() => handleTag("全部")}
          />
        </div>
      )}

      <Pagination page={currentPage} totalPages={totalPages} onChange={setPage} />
    </div>
  );
}